import { ActionTree, GetterTree, MutationTree } from "vuex";
export class State {
  public accountAddress?: string = undefined;
  public addressVerified = false;
  public hasProvider = false;
  public savedAccountAddress?: string = undefined;
}

const mutations: MutationTree<State> = {
  accountAddress(state: State, accountAddress?: string) {
    if (accountAddress && accountAddress.length === 0) {
      accountAddress = undefined;
    }
    state.accountAddress = accountAddress;
  },

  hasProvider(state: State, hasProvider: boolean) {
    state.hasProvider = hasProvider;
  },
};

const getters: GetterTree<State, any> = {
  walletIsActive(state: State): boolean {
    if (!state.hasProvider) {
      return false;
    }

    if (!state.addressVerified) {
      return false;
    }

    if (!state.accountAddress || state.accountAddress === "") {
      return false;
    }

    if (!state.savedAccountAddress || state.savedAccountAddress === "") {
      return false;
    }

    if (state.savedAccountAddress !== state.accountAddress) {
      return false;
    }

    return true;
  },
};

const actions: ActionTree<State, any> = {};

export const web3 = {
  namespaced: true,
  state: new State(),
  getters,
  mutations,
  actions,
};
